import { Navigate } from "react-router-dom";
import GuestLayout from "../layouts/guest-layout";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Centres from "../pages/Centres";
import Formations from "../pages/Formations";
import Course from "../pages/Course";
import GuestRoute from "./guest-route";
import CourseDetail from "../pages/Marketplace/Module/detail";
import EventDetailPage from "../pages/Marketplace/Event/detail";
import CustomerDetail from "../pages/Marketplace/Customer/detail";
import Quote from "../pages/Marketplace/Quote";
import Company from "../pages/Marketplace/Quote/Company.";
import Individual from "../pages/Marketplace/Quote/Individual";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";
import ProtectedRoute from "../components/Common/ProtectedRoute";
import ReservationForm from "../pages/Marketplace/Reservation";
import ReservationRecap from "../pages/Marketplace/Reservation/ReservationRecap";

const guestRoutes = {
  path: "/",
  element: <GuestLayout />,
  children: [
    { index: true, element: <Course /> },
    { path: "centres", element: <Centres /> },
    { path: "formations", element: <Formations /> },
    { path: "cours", element: <Course /> },
    { path: "centres", element: <Centres /> },
    { path: "formations", element: <Formations /> },
    { path: "cours/detail/:moduleId", element: <CourseDetail /> },
    { path: "evenement/detail/:projectId", element: <EventDetailPage /> },
    { path: "cfp/detail/:customerId", element: <CustomerDetail /> },
    { path: "devis/:idCfp/:idModule", element: <Quote /> },
    { path: "devis/company/:idModule", element: <Company /> },
    { path: "devis/individual/:idModule", element: <Individual /> },
    {
      path: "reservation/:projectId",
      element: (
        <ProtectedRoute allowedUserTypes={["superAdminEtp", "adminEtp"]}>
          <ReservationForm />
        </ProtectedRoute>
      ),
    },
    {
      path: "login",
      element: (
        <GuestRoute>
          <Login />
        </GuestRoute>
      ),
    },
    {
      path: "register",
      element: (
        <GuestRoute>
          <Register />
        </GuestRoute>
      ),
    },
    {
      path: "forgot-password",
      element: (
        <GuestRoute>
          <ForgotPassword />
        </GuestRoute>
      ),
    },
    {
      path: "reset-password",
      element: (
        <GuestRoute>
          <ResetPassword />
        </GuestRoute>
      ),
    },
    {
      path: "marketplace/reservation/recap/:id",
      element: <ReservationRecap />,
    },
  ],
};

export default guestRoutes;
